import _ from 'underscore';

function Driver(data) {
    if (data) {
        _.extend(this, data);
        if (!data.dateOfBirth) {
            data.dateOfBirth = null;
        }
        if (data.person) {
            if (!areDriverValuesUndefined(data.person)) {
                this.licenseState = data.person.licenseState || data.person.primaryAddress.state;
                this.licenseNumber = data.person.licenseNumber;
                this.gender = data.person.gender;
            }
            this.dateOfBirth = data.person.dateOfBirth;
        }
    }
}

function areDriverValuesUndefined(personObj) {
    var licenseState = personObj.licenseState,
        licenseNumber = personObj.licenseNumber,
        gender = personObj.gender,
        dateOfBirth = personObj.dateOfBirth,
        primaryAddress = personObj.primaryAddress;

    var statesStatus = licenseState === undefined || primaryAddress.state === undefined;
    return statesStatus === undefined || licenseNumber === undefined || gender === undefined || dateOfBirth === undefined;
}

Driver.prototype.getDisplayName = function (defaultName, $filter) {
    if (this.person.firstName === '0dummyname0') {
        return '';
    }
    return this.person.getDisplayName(defaultName, $filter);
};

Driver.prototype.getDriverStatesForCountry = function (states, countryCode) {
    return _.filter(states, function (state) {
        var countryConstraint = _.find(state.categories, function (constraint) {
            return _.keys(constraint).indexOf('Country') !== -1;
        });
        if (countryConstraint) {
            return countryConstraint.Country === countryCode;
        }
        return false;
    });
};

export default Driver;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/pa/models/Driver.js
// module id = 1203
// module chunks = 0